import { Component, OnInit } from '@angular/core';
import { HsgSubNavService } from '@hhsg/hsg-asc';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Constants } from '../../../shared/utilities/constants.util';
import { PermissionsService } from '../../../shared/services/permissions.service';
import { RouteUtil } from '../../../shared/utilities/route.util';
import { SubItemLink } from '../../../shared/models/sub-itemlink.model';
import { UserPermissions } from '../../../shared/models/user-permissions.model';
import { UserService } from '../../../shared/services/user.service';
import { ReportFilters } from 'src/shared/models/report-filters.model';
import { ReportService } from 'src/shared/services/report.service';


@Component({
  selector: 'smt-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
    user: UserPermissions = null;
    links: SubItemLink[] = [];

    reportFilters: ReportFilters;

    private selectionSubscription: Subscription;
    private _unsubscribe$ = new Subject();

    constructor(
        private subNav: HsgSubNavService, 
        private permissionsService: PermissionsService, 
        private userService: UserService,
        private reportService: ReportService) { 
        this.subNav.setSubNavData({
          title: "Reports",
          links: this.links
        });  
        
        this.selectionSubscription = this.reportService.summarySelection$.subscribe(
            (selection) => {
                switch(selection)
                {
                    case Constants.AcuitySummary:
                        this.loadAcuitySubNavLinks();
                        break;
                    case Constants.NurseSummary:
                        this.loadInpatientSubNavLinks();
                        break;
                    case Constants.TotalUosSummary:
                        this.loadTotalUosSubNavLinks();
                        break;
                    case Constants.ExecutiveVariance:
                        this.loadExecutiveVarianceSubNavLinks();
                        break;
                }
            }
        )
    }

    async ngOnInit() {
        this.permissionsService.userPermissions$
            .pipe(takeUntil(this._unsubscribe$))
			.subscribe(async (user: UserPermissions) => {
                this.user = user;
                
                if (this.user) {
                    this.checkSubLinks();
                }
                else {
                    let userPermissions = await this.userService.getUserPermissions();
        
                    if (userPermissions) {
                        this.permissionsService.announceUserPermissions(userPermissions);
                    }
                }
            });
    }

    private checkSubLinks() {
        this.links = this.links.filter(s => !RouteUtil.isPageViewable(this.user, RouteUtil.getPageByRoute(s.href)));
    }

    private loadAcuitySubNavLinks() {
        this.loadSubNavPages(Constants.AcuityReportsSubNavPages);
    }

    private loadInpatientSubNavLinks() {
        this.loadSubNavPages(Constants.InpatientReportsSubNavPages);
    }

    private loadTotalUosSubNavLinks() {
        this.loadSubNavPages(Constants.TotalUosReportsSubNavPages);
    }

    private loadExecutiveVarianceSubNavLinks()
    {
        this.loadSubNavPages(Constants.ExecutiveVarianceSubNavPages);
    }

    private loadSubNavPages(pages: string[][]) {        
        this.links = [];

        this.subNav.setSubNavData({
            title: "Reports",
            links: this.links
        }); 

        pages.forEach((page) => {
            let pageName = page[0];
            let displayName = page[2];
            this.links.push({ href: RouteUtil.findPageRoute(this.user, pageName), name: displayName });
        });
    }
}
